import { RouteComponentProps } from "react-router-dom"
import Board from "../../../boards/components/Board"
import { useProject } from "../../../projects/hooks/use-project"
import CircularProgress from "@material-ui/core/CircularProgress"
import ErrorList from "../../../components/ErrorList"
import { useTranslation } from "react-i18next"
import { useGetBoardV2Query } from "../../../boards/api/v2"

type RouteParams = { projectId: string }

const queryOptions = { refetchOnMountOrArgChange: true } as const

const ProjectKanbanRoute = ({ match }: RouteComponentProps<RouteParams>) => {
  const translations = useTranslations()
  const { projectId } = match.params
  const { project, isLoading: isLoadingProject } = useProject(projectId, queryOptions)
  const {
    data: board,
    isLoading: isLoadingBoard,
    isError,
  } = useGetBoardV2Query({ id: projectId, type: "project" }, queryOptions)

  if (isLoadingBoard || isLoadingProject) return <CircularProgress />
  if (isError) return <ErrorList errors={[translations.fetchErrorBoard]} />
  if (!board) return <ErrorList errors={[translations.boardNotFoundError]} />
  if (!project) return <ErrorList errors={[translations.projectNotFoundError]} />

  return <Board board={board} canAddTasks={project.canCreateProjectTasks} canAddTodos={project.canCreateProjectTodos} />
}

const defaultTranslations = {
  fetchErrorBoard: "Failed to fetch board",
  boardNotFoundError: "Board not found",
  projectNotFoundError: "Project not found",
}

const useTranslations = (): typeof defaultTranslations => {
  const { t } = useTranslation("translation")

  return {
    fetchErrorBoard: t("fetchErrorBoard", defaultTranslations.fetchErrorBoard),
    boardNotFoundError: t("boardNotFoundError", defaultTranslations.boardNotFoundError),
    projectNotFoundError: t("projectNotFoundError", defaultTranslations.projectNotFoundError),
  }
}

export default ProjectKanbanRoute
